/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 require('./bootstrap');
 require("jquery");
 require('bootstrap-select');
 
 require('./app-custom');
 
 //fixes an issue with ie 11 for vue-axios
 import Es6Promise from 'es6-promise';
 Es6Promise.polyfill();

 import Vue from 'vue';
 
 window.events = new Vue();
 window.loadedScripts = {};
 
 import { createElement, defineAsyncComponent } from "vue";
 
 /* import VueRouter from 'vue-router';
 Vue.use(VueRouter);*/
 
 //https://www.npmjs.com/package/vue-axios
 import VueAxios from 'vue-axios';
 import axios from 'axios';
 Vue.use(VueAxios, axios); 

//https://vcalendar.io/
import VCalendar from 'v-calendar';
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  locale: 'en-gb',
  masks: {
    input: 'DD/MM/YYYY'
  }
});
 
 //https://www.digitalocean.com/community/tutorials/vuejs-async-computed-properties
 import AsyncComputed from 'vue-async-computed'
 Vue.use(AsyncComputed)
 
 //https://github.com/jarvelov/vue-form-json-schema
 import VueFormJsonSchema from 'vue-form-json-schema';
 Vue.component('vue-form-json-schema', VueFormJsonSchema);
 
 //https://www.npmjs.com/package/vue-drag-drop
 import VueDragDrop from 'vue-drag-drop';
 Vue.use(VueDragDrop);
 
 //https://ckeditor.com/docs/ckeditor4/latest/guide/dev_vue.html
 import CKEditor from 'ckeditor4-vue';
 Vue.use( CKEditor );

// Vue html to paper
import VueHtmlToPaper from "vue-html-to-paper";
Vue.config.productionTip = false;
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};
Vue.use(VueHtmlToPaper, options);

   
 //https://bootstrap-vue.org/
 import { AlertPlugin, BootstrapVue, IconsPlugin,  ButtonPlugin, CollapsePlugin, ModalPlugin, OverlayPlugin, PaginationPlugin, PopoverPlugin, ProgressPlugin, TabsPlugin, ToastPlugin } from 'bootstrap-vue';
 // Import Bootstrap and BootstrapVue CSS files (order is important)
  //import 'bootstrap/dist/css/bootstrap.css'
  //import 'bootstrap-vue/dist/bootstrap-vue.css'

 Vue.use(AlertPlugin);
 Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
 Vue.use(ButtonPlugin);
 Vue.use(CollapsePlugin);
 Vue.use(ModalPlugin);
 Vue.use(OverlayPlugin);
 Vue.use(PaginationPlugin);
 Vue.use(PopoverPlugin);
 Vue.use(ProgressPlugin);
 Vue.use(TabsPlugin);
 Vue.use(ToastPlugin);

//https://nightcatsama.github.io/vue-slider-component/#/
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)
 
 /**
  * The following block of code may be used to automatically register your
  * Vue components. It will recursively scan this directory for the Vue
  * components and automatically register them with their "basename".
  *
  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
  */
 
 //const files = require.context('./', true, /\.vue$/i)
 //files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
 
 //set up global parameters for use in all vue components
 const globalVar = Vue.observable({ 
     editableFormsIndustry: 0,
     editableFormsJobType: 0,
     editableFormQuestionValuesUpdateNumber: 0,
     editableFormQuestionValues: {},
     editableFormParentForms: {},
     searchSchoolId: 0,
     searchCourseId: 0,
     searchAcademicYearId: (new Date().getMonth() < 7) ? new Date().getFullYear()-1 : new Date().getFullYear(),
     searchDateAcademicYearId: -1,
     listSchoolIds: [],
     reportJobs: [],
     autoSaveJobs: [],
     wexModal: {
        showModal: function(text='', options={}){}
     }
 });
 
 Object.defineProperty(Vue.prototype, '$editableFormsIndustry', {
     get () {
       return globalVar.editableFormsIndustry
     },
     
     set (value) {
       globalVar.editableFormsIndustry = value
     }
 });
 
 Object.defineProperty(Vue.prototype, '$editableFormsJobType', {
   get () {
     return globalVar.editableFormsJobType
   },
   
   set (value) {
     globalVar.editableFormsJobType = value
   }
 });

 Object.defineProperty(Vue.prototype, '$editableFormQuestionValues', {
  get () {
    return globalVar.editableFormQuestionValues
  },
  
  set (value) {
    globalVar.editableFormQuestionValues = value
  }
});

Object.defineProperty(Vue.prototype, '$editableFormQuestionValuesUpdateNumber', {
  get () {
    return globalVar.editableFormQuestionValuesUpdateNumber
  },
  
  set (value) {
    globalVar.editableFormQuestionValuesUpdateNumber = value
  }
});

Object.defineProperty(Vue.prototype, '$editableFormParentForms', {
  get () {
    return globalVar.editableFormParentForms
  },
  
  set (value) {
    globalVar.editableFormParentForms = value
  }
});
 
 Object.defineProperty(Vue.prototype, '$searchSchoolId', {
   get () {
     return globalVar.searchSchoolId
   },
   
   set (value) {
     globalVar.searchSchoolId = value
   }
 });

 Object.defineProperty(Vue.prototype, '$searchCourseId', {
  get () {
    return globalVar.searchCourseId
  },
  
  set (value) {
    globalVar.searchCourseId = value
  }
});

 Object.defineProperty(Vue.prototype, '$searchDateAcademicYearId', {
  get () {
    return globalVar.searchDateAcademicYearId
  },
  
  set (value) {
    globalVar.searchDateAcademicYearId = value
  }
});

 Object.defineProperty(Vue.prototype, '$searchAcademicYearId', {
  get () {
    return globalVar.searchAcademicYearId
  },
  
  set (value) {
    globalVar.searchAcademicYearId = value
  }
});

 Object.defineProperty(Vue.prototype, '$listSchoolIds', {
   get () {
     return globalVar.listSchoolIds
   },
   
   set (value) {
     globalVar.listSchoolIds = value
   }
 });

 Object.defineProperty(Vue.prototype, '$reportJobs', {
  get () {
    return globalVar.reportJobs
  },
  
  set (value) {
    globalVar.reportJobs = value
  }
});

Object.defineProperty(Vue.prototype, '$autoSaveJobs', {
  get () {
    return globalVar.autoSaveJobs
  },
  
  set (value) {
    globalVar.autoSaveJobs = value
  }
});

Object.defineProperty(Vue.prototype, '$wexModal', {
  get () {
    return globalVar.wexModal
  },
  
  set (value) {
    globalVar.wexModal = value
  }
});